import Vue from 'vue'
import App from './App.vue'
import router from "./router";

import "@/styles/index.scss"; // global css
import "@/styles/common.scss"; // global css

import "@/utils/rem"; //字体适配
import "@/utils/date"; //日期扩展

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts 
import AmapVueConfig from '@amap/amap-vue/lib/config';//引入地图
AmapVueConfig.key='b70c1546c69d5c5dd4bdab5c6e1c5ec0'
// import AmapVue from '@amap/amap-vue';
// AmapVue.config.version = '2.0'; // 默认2.0，这里可以不修改
// AmapVue.config.key = 'b70c1546c69d5c5dd4bdab5c6e1c5ec0';
// AmapVue.config.plugins = [
//   'AMap.ToolBar',
//   'AMap.MoveAnimation',
//   // 在此配置你需要预加载的插件，如果不配置，在使用到的时候会自动异步加载
// ];
// Vue.use(AmapVue);
// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// export default vConsole
//路由变化时页面在最顶部
// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0);
// });
Vue.config.productionTip = false;


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
